export const font = {
  regular: "'Roboto', sans-serif",
  medium: "'Roboto', sans-serif",
  semiBold: "'Roboto', sans-serif",
  bold: "'Roboto', sans-serif"
};
